import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { TooltipModule } from 'primeng/tooltip';
import { DialogLink } from 'src/app/components/link-button/link-button';
import { NotificationService } from 'src/app/services/notification.service';
import { copyToClipboard } from 'src/app/utils/copy';
import { MeetingLinkDocentDTO } from '../../models/meeting-link-docent-dto.model';
import { MeetingLinkCourseSelfStudyDTO } from '../../models/meeting-link-course-self-study-dto.model';

@Component({
  selector: 'app-meeting-link-readonly-actions',
  standalone: true,
  imports: [ButtonModule, DialogLink, FloatLabelModule, TooltipModule],
  templateUrl: './meeting-link-readonly-actions.component.html',
  styleUrl: './meeting-link-readonly-actions.component.scss',
})
export class MeetingLinkReadonlyActionsComponent {
  /**
   * Gerendert wird ausschließlich anhand von meetingLink — damit funktioniert die Komponente
   * auch für Zoom-Raumlinks, die keine meetingId haben.
   */
  @Input({ required: true }) meetingData:
    | MeetingLinkDocentDTO
    | MeetingLinkCourseSelfStudyDTO
    | { meetingLink?: string | null };

  /** Leer heißt: nur das Icon — so sieht es in den Tabellenzeilen aus. */
  @Input() label = '';

  copyToClipboard = copyToClipboard;

  // Wird nicht direkt aufgerufen: copyToClipboard greift als Methode der Komponente darauf zu.
  constructor(readonly notificationService: NotificationService) {}
}
